// extracted by mini-css-extract-plugin
export default {"spinner":"spinner_spinner__XTDRZ","rotate":"spinner_rotate__gnAjk","path":"spinner_path__vzWHI","dash":"spinner_dash__0drpU"};